export default "__VITE_ASSET__DyY0c3SB__"